import React, { useEffect, useMemo, useState } from "react";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../appConstants";
import { Button, DialogContent, Drawer, Input, Option, Select, selectClasses, Skeleton, Tooltip } from "@mui/joy";
import AddBulkScheduleModal from "./AddBulkScheduleModal";
import UpcomingTable from "./UpcomingTable";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { getNextMonthLastDate, getDateString, getFutureDate } from "../../appFunctions";

import { debounce } from "lodash";
import { useSelector } from "react-redux";
import axios from "axios";

type FilterStateObj = {
    status?: string,
    type?: string,
    schedule_status?: string,
    start_date?: string,
    schedule_date?: string,
    file_name?: string
}
const LatestFiles: React.FC = () => {
    const { brand_id: brandId } = useSelector((state: any) => state.appData);
    const [selectedTab, setSelectedTab] = useState<string>("UPCOMING");
    const [openModal, setOpenModal] = useState(false);
    const [refrest, setRefresh] = useState<boolean>(false);
    const [filter, setFilter] = useState(false);

    const [filterState, setFilterState] = useState<FilterStateObj>({
        status: "",
        type: "",
        schedule_status: "",
        start_date: "",
        schedule_date: "",
        file_name: ""
    });

    const [searchFileArray, setSearchFileArray] = useState<{ file_name: string }[]>([]);
    // const [fileSearch, setFileSearch] = useState("");
    const [searchFocus, setSearchFocus] = useState(false);
    const [searchFile, setSearchFile] = useState<string>("");

    const onFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // setSelected(false);
        // setSearchType("");
        if (e.target.value?.trimStart()) {
            setSearchFocus(true);
        } else {
            setSearchFocus(false);
            setFilterState({} as FilterStateObj);
        }
        setSearchFile(e.target.value?.trimStart());
    }

    const fetchProductSearchData = debounce(async () => {
        const token = localStorage.getItem("token");
        (async () => {
            try {
                let api = `${BASE_URL}brand/getSuggestFile?brand_id=${brandId}&file_name=${searchFile}`;
                const headers = {
                    "Authorization": `Bearer ${token}`
                }
                const result = await axios.get(api, { headers });
                const { file_name_array } = result?.data?.data;
                setSearchFileArray(file_name_array);
            } catch {

            } finally {

            }
        })();
    }, 500)

    useEffect(() => {
        if (searchFile) {
            fetchProductSearchData.cancel();
            fetchProductSearchData();
        }
        return () => {
            fetchProductSearchData.cancel();
        }
    }, [searchFile]);

    const onTabChange = (tab: string, url: string) => {
        setSelectedTab(tab);
        // navigate(url);
    }


    const toggleDrawer = (open: boolean, product: null) => {
        setFilter(open);
    };

    const onSelectChangeHandler = (event: any, value: any, name: string) => {
        setFilterState((prevState) => ({ ...prevState, [name]: value }));
    }

    const onDateUpcomingChangeHandler = (dateObje: Dayjs | null) => {

        const date = dateObje?.date();
        const month = dateObje?.month();
        const year = dateObje?.year();

        const time_stamp = new Date(`${year}-${month as number + 1}-${date}`);
        const date_string = getDateString(time_stamp);
        setFilterState((prevState) => ({ ...prevState, schedule_date: date_string }));

    }



    const onDateStartChangeHandler = (dateObje: Dayjs | null) => {

        const date = dateObje?.date();
        const month = dateObje?.month();
        const year = dateObje?.year();

        const time_stamp = new Date(`${year}-${month as number + 1}-${date}`);
        const date_string = getDateString(time_stamp);
        setFilterState((prevState) => ({ ...prevState, start_date: date_string }));

    }


    const onSaveClickHandler = () => {
        setRefresh(prevState => !prevState);
        toggleDrawer(false, null)
    }

    const onClearFilter = () => {
        setRefresh(prevState => !prevState);
        setFilterState(
            {
                status: "",
                type: "",
                schedule_status: "",
                start_date: "",
                schedule_date: "",
            }
        )
    }

    const onKeyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if (e?.key === "Enter") {
            setSearchFocus(false);
            setFilterState((prevState) => ({ ...prevState, file_name: searchFile }));
        }
    }

    const onSearchButtonClick = () => {
        setSearchFocus(false);
        setFilterState((prevState) => ({ ...prevState, file_name: searchFile }));
    }

    const selectKeyword = (fileName: string) => {
        setSearchFile(fileName);
        setSearchFocus(false);
        setFilterState((prevState) => ({ ...prevState, file_name: fileName }));
    };

    return (
        <>
            <div className="flex flex-row justify-between  p-6 mb-6" style={{ height: 96, backgroundColor: PRIMARY.P_Purple50, borderRadius: 8 }} >
                <div className="flex flex-col justify-between" >
                    <div style={{ fontSize: "16px", fontWeight: 600, lineHeight: "24px", color: BLACK.B_100 }}>Add New Bulk Schedule</div>
                    <div style={{ fontSize: 12, fontWeight: 400, lineHeight: "18px", color: BLACK.B_40 }} >Provide the information for the new bulk schedule here</div>
                </div>
                <Button
                    //loading={lodingOnSave}
                    onClick={() => setOpenModal(true)}
                    startDecorator={
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M9.16663 10.8333H4.99996C4.76385 10.8333 4.56593 10.7534 4.40621 10.5937C4.24649 10.434 4.16663 10.2361 4.16663 9.99996C4.16663 9.76385 4.24649 9.56593 4.40621 9.40621C4.56593 9.24649 4.76385 9.16663 4.99996 9.16663H9.16663V4.99996C9.16663 4.76385 9.24649 4.56593 9.40621 4.40621C9.56593 4.24649 9.76385 4.16663 9.99996 4.16663C10.2361 4.16663 10.434 4.24649 10.5937 4.40621C10.7534 4.56593 10.8333 4.76385 10.8333 4.99996V9.16663H15C15.2361 9.16663 15.434 9.24649 15.5937 9.40621C15.7534 9.56593 15.8333 9.76385 15.8333 9.99996C15.8333 10.2361 15.7534 10.434 15.5937 10.5937C15.434 10.7534 15.2361 10.8333 15 10.8333H10.8333V15C10.8333 15.2361 10.7534 15.434 10.5937 15.5937C10.434 15.7534 10.2361 15.8333 9.99996 15.8333C9.76385 15.8333 9.56593 15.7534 9.40621 15.5937C9.24649 15.434 9.16663 15.2361 9.16663 15V10.8333Z" fill="white" />
                        </svg>
                    }
                    sx={{
                        height: "48px",
                        width: "200px",
                        fontWeight: 500,
                        fontSize: 14,
                        lineHeight: "20px",
                        backgroundColor: PRIMARY.P_BLue,
                    }}
                >Add Bulk Schedule</Button>
            </div>

            <div className="flex justify-between mb-4 cursor-pointer" >
                <div className="flex">
                    <div onClick={(e) => e.stopPropagation()} style={{ zIndex: 99, display: "flex", position: "relative", flexDirection: "row", alignItems: "center" }} >
                        <Input
                            onChange={onFileInputChange}
                            value={searchFile}
                            onKeyDown={onKeyDownHandler}
                            placeholder="Search"
                            startDecorator={
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M17.9421 17.0578L14.0304 13.1469C15.1642 11.7857 15.7295 10.0398 15.6089 8.27244C15.4882 6.50506 14.6908 4.85223 13.3825 3.65779C12.0743 2.46334 10.3559 1.81926 8.58486 1.85951C6.81382 1.89976 5.12647 2.62125 3.87383 3.87389C2.62118 5.12653 1.89969 6.81388 1.85944 8.58492C1.8192 10.356 2.46328 12.0744 3.65772 13.3826C4.85217 14.6909 6.50499 15.4883 8.27238 15.6089C10.0398 15.7296 11.7856 15.1642 13.1468 14.0305L17.0577 17.9422C17.1158 18.0003 17.1848 18.0463 17.2606 18.0777C17.3365 18.1092 17.4178 18.1253 17.4999 18.1253C17.5821 18.1253 17.6634 18.1092 17.7392 18.0777C17.8151 18.0463 17.8841 18.0003 17.9421 17.9422C18.0002 17.8841 18.0463 17.8152 18.0777 17.7393C18.1091 17.6634 18.1253 17.5821 18.1253 17.5C18.1253 17.4179 18.1091 17.3366 18.0777 17.2607C18.0463 17.1848 18.0002 17.1159 17.9421 17.0578ZM3.12493 8.75C3.12493 7.63748 3.45483 6.54994 4.07292 5.62491C4.691 4.69989 5.56951 3.97892 6.59734 3.55317C7.62517 3.12743 8.75617 3.01604 9.84732 3.23308C10.9385 3.45012 11.9407 3.98585 12.7274 4.77252C13.5141 5.55919 14.0498 6.56147 14.2669 7.65261C14.4839 8.74376 14.3725 9.87475 13.9468 10.9026C13.521 11.9304 12.8 12.8089 11.875 13.427C10.95 14.0451 9.86245 14.375 8.74993 14.375C7.2586 14.3733 5.82882 13.7802 4.77429 12.7256C3.71975 11.6711 3.12659 10.2413 3.12493 8.75Z" fill="#1C1C1C" fill-opacity="0.4" />
                                </svg>
                            }
                            sx={{
                                width: "320px",
                                height: "40px",
                                "--Input-focusedThickness": "0px",
                                borderBottom: searchFocus ? "0px" : `1px solid ${BLACK.B_10}`,
                                borderTop: `1px solid ${BLACK.B_10}`,
                                borderLeft: `1px solid ${BLACK.B_10}`,
                                borderRight: `1px solid ${BLACK.B_10}`,
                                borderBottomRightRadius: searchFocus ? "0px" : "6px",
                                borderBottomLeftRadius: searchFocus ? "0px" : "6px",
                                backgroundColor: WHITE.W_100,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                boxShadow: "none",
                            }}
                        />
                        {
                            searchFocus &&
                            (
                                <div style={{
                                    position: "absolute",
                                    top: 40,
                                    left: 0,
                                    width: 320,
                                    borderBottomRightRadius: "6px",
                                    borderBottomLeftRadius: "6px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    borderBottom: `1px solid ${BLACK.B_10}`,
                                    borderLeft: `1px solid ${BLACK.B_10}`,
                                    borderRight: `1px solid ${BLACK.B_10}`,
                                    backgroundColor: WHITE.W_100
                                }}>
                                    <div style={{ width: 302, flex: 1, paddingTop: 16, borderTop: `1px solid ${BLACK.B_10}`, maxHeight: 200, overflow: "auto" }} >
                                        {
                                            searchFileArray?.map(file => {
                                                return (
                                                    <div
                                                        key={file.file_name}
                                                        onClick={() => selectKeyword(file.file_name)}
                                                        style={{ cursor: "pointer", marginBottom: 16, display: "flex", flexDirection: "column", justifyContent: "space-between", height: 26 }} >
                                                        <div style={{ height: 20, fontSize: 14, fontWeight: 400, color: BLACK.B_100 }} >
                                                            {file.file_name}
                                                        </div>
                                                    
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <Button
                        sx={{
                            height: 40,
                            width: 120,
                            fontSize: 14,
                            fontWeight: 500,
                            backgroundColor: PRIMARY.P_BLue,
                            lineHeight: "20px",
                            ":hover": {
                                backgroundColor: PRIMARY.P_BLue
                            },
                            marginLeft: "12px",
                            borderRadius: 8
                        }}
                        onClick={onSearchButtonClick}
                    >Search</Button>
                </div>
                <div onClick={() => toggleDrawer(true, null)} className="flex items-center justify-center" style={{ height: 40, width: 94, borderRadius: 8, border: `1px solid ${BLACK.B_5}` }} >
                    <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10ZM18.125 5.625H1.875C1.70924 5.625 1.55027 5.69085 1.43306 5.80806C1.31585 5.92527 1.25 6.08424 1.25 6.25C1.25 6.41576 1.31585 6.57473 1.43306 6.69194C1.55027 6.80915 1.70924 6.875 1.875 6.875H18.125C18.2908 6.875 18.4497 6.80915 18.5669 6.69194C18.6842 6.57473 18.75 6.41576 18.75 6.25C18.75 6.08424 18.6842 5.92527 18.5669 5.80806C18.4497 5.69085 18.2908 5.625 18.125 5.625ZM11.875 13.125H8.125C7.95924 13.125 7.80027 13.1908 7.68306 13.3081C7.56585 13.4253 7.5 13.5842 7.5 13.75C7.5 13.9158 7.56585 14.0747 7.68306 14.1919C7.80027 14.3092 7.95924 14.375 8.125 14.375H11.875C12.0408 14.375 12.1997 14.3092 12.3169 14.1919C12.4342 14.0747 12.5 13.9158 12.5 13.75C12.5 13.5842 12.4342 13.4253 12.3169 13.3081C12.1997 13.1908 12.0408 13.125 11.875 13.125Z" fill="#1C1C1C" />
                    </svg>
                    Filter
                </div>
            </div>

            <UpcomingTable route="allFiles" filterState={filterState} refrest={refrest} />

            <Drawer
                key={'right'}
                anchor={"right"}
                open={filter}
             //   onClose={() => toggleDrawer(false, null)}
                size="sm"
                sx={{

                }}


            >
                <div className="flex flex-row justify-between p-6" style={{ height: 72, borderBottom: `1px solid ${BLACK.B_10}` }} >
                    <div style={{ fontSize: 18, fontWeight: 500, lineHeight: "24px", color: BLACK.B_100 }} >Filters</div>
                    <div className="w-fit cursor-pointer" onClick={() => toggleDrawer(false, null)} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z" fill="#1C1C1C" />
                        </svg>
                    </div>
                </div>
                <DialogContent sx={{ paddingTop: "40px", paddingBottom: "16px", paddingX: "24px" }} >

                    <div className="mb-6" style={{ height: 72 }} >
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_40 }} >State</div>
                        <Select
                            onChange={(e1, e2) => onSelectChangeHandler(e1, e2, "status")}
                            placeholder="Select State"
                            name="status"
                            value={filterState?.status}
                            indicator={
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 12.4791C9.88891 12.4791 9.78474 12.4617 9.68752 12.427C9.5903 12.3923 9.50002 12.3333 9.41669 12.2499L5.58335 8.41659C5.43058 8.26381 5.35419 8.06936 5.35419 7.83325C5.35419 7.59714 5.43058 7.4027 5.58335 7.24992C5.73613 7.09714 5.93058 7.02075 6.16669 7.02075C6.4028 7.02075 6.59724 7.09714 6.75002 7.24992L10 10.4999L13.25 7.24992C13.4028 7.09714 13.5972 7.02075 13.8334 7.02075C14.0695 7.02075 14.2639 7.09714 14.4167 7.24992C14.5695 7.4027 14.6459 7.59714 14.6459 7.83325C14.6459 8.06936 14.5695 8.26381 14.4167 8.41659L10.5834 12.2499C10.5 12.3333 10.4097 12.3923 10.3125 12.427C10.2153 12.4617 10.1111 12.4791 10 12.4791Z" fill="#1C1C1C" fill-opacity="0.4" />
                                </svg>

                            }
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "100%",
                                height: "52px",
                                backgroundColor: WHITE.W_100,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                border: `1px solid ${BLACK.B_10}`,
                                [`& .${selectClasses.indicator}`]: {
                                    transition: '0.2s',
                                    [`&.${selectClasses.expanded}`]: {
                                        transform: 'rotate(-180deg)',
                                    },
                                },
                            }}>
                            <Option value={"ACTIVE"} >Active</Option>
                            <Option value={"PAUSED"} >Paused</Option>
                            <Option value={"CANCELLED"} >Cancelled</Option>
                            {/* <Option value={"CLIENT"}>CLIENT</Option> */}
                        </Select>
                    </div>

                    <div className="mb-6" style={{ height: 72 }} >
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_40 }} >Schedule Type</div>
                        <Select
                            onChange={(e1, e2) => onSelectChangeHandler(e1, e2, "type")}
                            placeholder="Select Schedule Type"
                            name="type"
                            value={filterState?.type}
                            indicator={
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 12.4791C9.88891 12.4791 9.78474 12.4617 9.68752 12.427C9.5903 12.3923 9.50002 12.3333 9.41669 12.2499L5.58335 8.41659C5.43058 8.26381 5.35419 8.06936 5.35419 7.83325C5.35419 7.59714 5.43058 7.4027 5.58335 7.24992C5.73613 7.09714 5.93058 7.02075 6.16669 7.02075C6.4028 7.02075 6.59724 7.09714 6.75002 7.24992L10 10.4999L13.25 7.24992C13.4028 7.09714 13.5972 7.02075 13.8334 7.02075C14.0695 7.02075 14.2639 7.09714 14.4167 7.24992C14.5695 7.4027 14.6459 7.59714 14.6459 7.83325C14.6459 8.06936 14.5695 8.26381 14.4167 8.41659L10.5834 12.2499C10.5 12.3333 10.4097 12.3923 10.3125 12.427C10.2153 12.4617 10.1111 12.4791 10 12.4791Z" fill="#1C1C1C" fill-opacity="0.4" />
                                </svg>

                            }
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "100%",
                                height: "52px",
                                backgroundColor: WHITE.W_100,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                border: `1px solid ${BLACK.B_10}`,
                                [`& .${selectClasses.indicator}`]: {
                                    transition: '0.2s',
                                    [`&.${selectClasses.expanded}`]: {
                                        transform: 'rotate(-180deg)',
                                    },
                                },
                            }}>
                            <Option value={"one_time"} >One Time</Option>
                            <Option value={"recurring"} >Recurring</Option>
                            {/* <Option value={"CLIENT"}>CLIENT</Option> */}
                        </Select>
                    </div>

                    <div className="mb-6" style={{ height: 72 }} >
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_40 }} >Start Date</div>
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                            <DesktopDatePicker
                                // minDate={dayjs(new Date())}
                                // maxDate={dayjs(getNextMonthLastDate())}
                                // defaultValue={dayjs(new Date())}

                                value={!filterState?.start_date ? null : dayjs(new Date(filterState?.start_date as string))}
                                onChange={onDateStartChangeHandler}
                                slots={{
                                    openPickerIcon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M6.6665 11.6186C6.46248 11.6186 6.28859 11.5467 6.14484 11.4031C6.00123 11.2594 5.92942 11.0855 5.92942 10.8815C5.92942 10.6774 6.00123 10.5036 6.14484 10.3598C6.28859 10.2161 6.46248 10.1442 6.6665 10.1442C6.87053 10.1442 7.04442 10.2161 7.18817 10.3598C7.33178 10.5036 7.40359 10.6774 7.40359 10.8815C7.40359 11.0855 7.33178 11.2594 7.18817 11.4031C7.04442 11.5467 6.87053 11.6186 6.6665 11.6186ZM9.99984 11.6186C9.79581 11.6186 9.62192 11.5467 9.47817 11.4031C9.33456 11.2594 9.26275 11.0855 9.26275 10.8815C9.26275 10.6774 9.33456 10.5036 9.47817 10.3598C9.62192 10.2161 9.79581 10.1442 9.99984 10.1442C10.2039 10.1442 10.3778 10.2161 10.5215 10.3598C10.6651 10.5036 10.7369 10.6774 10.7369 10.8815C10.7369 11.0855 10.6651 11.2594 10.5215 11.4031C10.3778 11.5467 10.2039 11.6186 9.99984 11.6186ZM13.3332 11.6186C13.1291 11.6186 12.9553 11.5467 12.8115 11.4031C12.6679 11.2594 12.5961 11.0855 12.5961 10.8815C12.5961 10.6774 12.6679 10.5036 12.8115 10.3598C12.9553 10.2161 13.1291 10.1442 13.3332 10.1442C13.5372 10.1442 13.7111 10.2161 13.8548 10.3598C13.9984 10.5036 14.0703 10.6774 14.0703 10.8815C14.0703 11.0855 13.9984 11.2594 13.8548 11.4031C13.7111 11.5467 13.5372 11.6186 13.3332 11.6186ZM4.42296 17.9167C4.00199 17.9167 3.64567 17.7708 3.354 17.4792C3.06234 17.1875 2.9165 16.8312 2.9165 16.4102V5.25647C2.9165 4.8355 3.06234 4.47918 3.354 4.18751C3.64567 3.89585 4.00199 3.75001 4.42296 3.75001H5.57671V2.62814C5.57671 2.4455 5.63789 2.293 5.76025 2.17064C5.88261 2.04842 6.03511 1.9873 6.21775 1.9873C6.40053 1.9873 6.55303 2.04842 6.67525 2.17064C6.79762 2.293 6.8588 2.4455 6.8588 2.62814V3.75001H13.173V2.6123C13.173 2.43494 13.2328 2.2864 13.3523 2.16668C13.4721 2.0471 13.6206 1.9873 13.798 1.9873C13.9753 1.9873 14.1238 2.0471 14.2434 2.16668C14.3631 2.2864 14.423 2.43494 14.423 2.6123V3.75001H15.5767C15.9977 3.75001 16.354 3.89585 16.6457 4.18751C16.9373 4.47918 17.0832 4.8355 17.0832 5.25647V16.4102C17.0832 16.8312 16.9373 17.1875 16.6457 17.4792C16.354 17.7708 15.9977 17.9167 15.5767 17.9167H4.42296ZM4.42296 16.6667H15.5767C15.6409 16.6667 15.6996 16.6399 15.753 16.5865C15.8064 16.5331 15.8332 16.4744 15.8332 16.4102V8.5898H4.1665V16.4102C4.1665 16.4744 4.19324 16.5331 4.24671 16.5865C4.30005 16.6399 4.3588 16.6667 4.42296 16.6667ZM4.1665 7.3398H15.8332V5.25647C15.8332 5.1923 15.8064 5.13355 15.753 5.08022C15.6996 5.02675 15.6409 5.00001 15.5767 5.00001H4.42296C4.3588 5.00001 4.30005 5.02675 4.24671 5.08022C4.19324 5.13355 4.1665 5.1923 4.1665 5.25647V7.3398Z" fill="#1C1C1C" fill-opacity="0.4" />
                                    </svg>
                                }}
                                format="DD-MMM-YY"
                                slotProps={{
                                    textField: {
                                        // placeholder: "Choose date",
                                        sx: {
                                            backgroundColor: WHITE.W_100,
                                            width: "100%",
                                            '& .MuiInputBase-root': {
                                                height: "52px"
                                            },
                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`,
                                                borderRadius: '8px'
                                            },

                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`
                                            },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`
                                            }
                                        },
                                        inputProps: {
                                            placeholder: "Choose date", // Placeholder

                                        },

                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </div>

                    <div className="mb-6" style={{ height: 72 }} >
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_40 }} >Upcoming Schedule Date</div>
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                            <DesktopDatePicker
                                // minDate={dayjs(new Date())}
                                // maxDate={dayjs(getNextMonthLastDate())}
                                //defaultValue={dayjs(new Date())}
                                value={!filterState?.schedule_date ? null : dayjs(new Date(filterState?.schedule_date as string))}
                                onChange={onDateUpcomingChangeHandler}
                                slots={{
                                    openPickerIcon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M6.6665 11.6186C6.46248 11.6186 6.28859 11.5467 6.14484 11.4031C6.00123 11.2594 5.92942 11.0855 5.92942 10.8815C5.92942 10.6774 6.00123 10.5036 6.14484 10.3598C6.28859 10.2161 6.46248 10.1442 6.6665 10.1442C6.87053 10.1442 7.04442 10.2161 7.18817 10.3598C7.33178 10.5036 7.40359 10.6774 7.40359 10.8815C7.40359 11.0855 7.33178 11.2594 7.18817 11.4031C7.04442 11.5467 6.87053 11.6186 6.6665 11.6186ZM9.99984 11.6186C9.79581 11.6186 9.62192 11.5467 9.47817 11.4031C9.33456 11.2594 9.26275 11.0855 9.26275 10.8815C9.26275 10.6774 9.33456 10.5036 9.47817 10.3598C9.62192 10.2161 9.79581 10.1442 9.99984 10.1442C10.2039 10.1442 10.3778 10.2161 10.5215 10.3598C10.6651 10.5036 10.7369 10.6774 10.7369 10.8815C10.7369 11.0855 10.6651 11.2594 10.5215 11.4031C10.3778 11.5467 10.2039 11.6186 9.99984 11.6186ZM13.3332 11.6186C13.1291 11.6186 12.9553 11.5467 12.8115 11.4031C12.6679 11.2594 12.5961 11.0855 12.5961 10.8815C12.5961 10.6774 12.6679 10.5036 12.8115 10.3598C12.9553 10.2161 13.1291 10.1442 13.3332 10.1442C13.5372 10.1442 13.7111 10.2161 13.8548 10.3598C13.9984 10.5036 14.0703 10.6774 14.0703 10.8815C14.0703 11.0855 13.9984 11.2594 13.8548 11.4031C13.7111 11.5467 13.5372 11.6186 13.3332 11.6186ZM4.42296 17.9167C4.00199 17.9167 3.64567 17.7708 3.354 17.4792C3.06234 17.1875 2.9165 16.8312 2.9165 16.4102V5.25647C2.9165 4.8355 3.06234 4.47918 3.354 4.18751C3.64567 3.89585 4.00199 3.75001 4.42296 3.75001H5.57671V2.62814C5.57671 2.4455 5.63789 2.293 5.76025 2.17064C5.88261 2.04842 6.03511 1.9873 6.21775 1.9873C6.40053 1.9873 6.55303 2.04842 6.67525 2.17064C6.79762 2.293 6.8588 2.4455 6.8588 2.62814V3.75001H13.173V2.6123C13.173 2.43494 13.2328 2.2864 13.3523 2.16668C13.4721 2.0471 13.6206 1.9873 13.798 1.9873C13.9753 1.9873 14.1238 2.0471 14.2434 2.16668C14.3631 2.2864 14.423 2.43494 14.423 2.6123V3.75001H15.5767C15.9977 3.75001 16.354 3.89585 16.6457 4.18751C16.9373 4.47918 17.0832 4.8355 17.0832 5.25647V16.4102C17.0832 16.8312 16.9373 17.1875 16.6457 17.4792C16.354 17.7708 15.9977 17.9167 15.5767 17.9167H4.42296ZM4.42296 16.6667H15.5767C15.6409 16.6667 15.6996 16.6399 15.753 16.5865C15.8064 16.5331 15.8332 16.4744 15.8332 16.4102V8.5898H4.1665V16.4102C4.1665 16.4744 4.19324 16.5331 4.24671 16.5865C4.30005 16.6399 4.3588 16.6667 4.42296 16.6667ZM4.1665 7.3398H15.8332V5.25647C15.8332 5.1923 15.8064 5.13355 15.753 5.08022C15.6996 5.02675 15.6409 5.00001 15.5767 5.00001H4.42296C4.3588 5.00001 4.30005 5.02675 4.24671 5.08022C4.19324 5.13355 4.1665 5.1923 4.1665 5.25647V7.3398Z" fill="#1C1C1C" fill-opacity="0.4" />
                                    </svg>
                                }}
                                format="DD-MMM-YY"
                                slotProps={{
                                    textField: {
                                        // placeholder: "Choose date",

                                        sx: {
                                            backgroundColor: WHITE.W_100,
                                            width: "100%",
                                            '& .MuiInputBase-root': {
                                                height: "52px"
                                            },
                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`,
                                                borderRadius: '8px'
                                            },

                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`
                                            },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`
                                            }
                                        },
                                        inputProps: {
                                            placeholder: "Choose date", // Placeholder

                                        },

                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </div>

                    <div className="mb-6" style={{ height: 72 }} >
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_40 }} >Schedule Status</div>
                        <Select
                            onChange={(e1, e2) => onSelectChangeHandler(e1, e2, "schedule_status")}
                            placeholder="Select Schedule Status"
                            name="schedule_status"
                            value={filterState?.schedule_status}
                            indicator={
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 12.4791C9.88891 12.4791 9.78474 12.4617 9.68752 12.427C9.5903 12.3923 9.50002 12.3333 9.41669 12.2499L5.58335 8.41659C5.43058 8.26381 5.35419 8.06936 5.35419 7.83325C5.35419 7.59714 5.43058 7.4027 5.58335 7.24992C5.73613 7.09714 5.93058 7.02075 6.16669 7.02075C6.4028 7.02075 6.59724 7.09714 6.75002 7.24992L10 10.4999L13.25 7.24992C13.4028 7.09714 13.5972 7.02075 13.8334 7.02075C14.0695 7.02075 14.2639 7.09714 14.4167 7.24992C14.5695 7.4027 14.6459 7.59714 14.6459 7.83325C14.6459 8.06936 14.5695 8.26381 14.4167 8.41659L10.5834 12.2499C10.5 12.3333 10.4097 12.3923 10.3125 12.427C10.2153 12.4617 10.1111 12.4791 10 12.4791Z" fill="#1C1C1C" fill-opacity="0.4" />
                                </svg>

                            }
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "100%",
                                height: "52px",
                                backgroundColor: WHITE.W_100,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                border: `1px solid ${BLACK.B_10}`,
                                [`& .${selectClasses.indicator}`]: {
                                    transition: '0.2s',
                                    [`&.${selectClasses.expanded}`]: {
                                        transform: 'rotate(-180deg)',
                                    },
                                },
                            }}>
                            <Option value={"UPCOMING"} >Upcoming</Option>
                            <Option value={"SUCCESSFUL"} >Successful</Option>
                            <Option value={"FAILED"} >Failed</Option>
                            {/* <Option value={"CLIENT"}>CLIENT</Option> */}
                        </Select>
                    </div>

                </DialogContent>
                <div className="flex items-center justify-between px-6" style={{ height: 88, borderTop: `1px solid ${BLACK.B_10}` }} >
                    <Button color="neutral"
                        sx={{
                            height: 40,
                            width: 150,
                            fontSize: 14,
                            fontWeight: 500,
                            backgroundColor: BLACK.B_5,
                            lineHeight: "20px",
                            color: BLACK.B_100,
                            ":hover": {
                                backgroundColor: BLACK.B_20,
                            }
                        }}
                        onClick={onClearFilter}
                    >Clear Filter</Button>
                    <Button
                        // loading={lodingOnSave}
                        sx={{
                            height: 40,
                            width: 150,
                            fontSize: 14,
                            fontWeight: 500,
                            backgroundColor: PRIMARY.P_BLue,
                            lineHeight: "20px",
                            ":hover": {
                                backgroundColor: PRIMARY.P_BLue
                            },
                            borderRadius: 8
                        }}
                        onClick={onSaveClickHandler}
                    >Save</Button>
                </div>
            </Drawer>
            {
                openModal && <AddBulkScheduleModal setRefresh={setRefresh} setOpenModal={setOpenModal} />
            }
        </>
    )
}

export default LatestFiles;